package com.bikompanion.ui.composables

import org.maplibre.compose.map.MapUiOptions

internal actual fun mapOptions() = MapUiOptions.Standard
